<template>

    <cms-action-grid>
        <cms-action-button icon="magicon-jump-down-left" :disabled="!canDeploy || disabled" @click="showActionModal('DEPLOY')">Inzetten</cms-action-button>
        <cms-action-button icon="magicon-jump-up-right" :disabled="!canReturn || disabled" @click="showActionModal('RETOUR')">Retour</cms-action-button>
        <cms-action-button icon="magicon-jump-right-up" v-if="userIsAdmin" :disabled="!canRelease || disabled" @click="showActionModal('RELEASE')">Vrijgeven</cms-action-button>
        <cms-action-button icon="entypo-warning" :disabled="!canRepairPending || disabled" @click="showActionModal('REPAIR_PENDING')">Behoeft reparatie</cms-action-button>
        <cms-action-button icon="entypo-tools" v-if="userIsAdmin" :disabled="!canRepairActive || disabled" @click="showActionModal('REPAIR_ACTIVE')">Reparatie aanmaken</cms-action-button>
        <cms-action-button icon="entypo-trash" v-if="userIsAdmin" :disabled="!canWriteOff || disabled" @click="showActionModal('WRITE_OFF')">Afschrijven</cms-action-button>
        <cms-action-button icon="entypo-flag" v-if="!actionMode" :disabled="!canCreateAction || disabled" @click="createAction">Actie aanmaken</cms-action-button>
        <cms-action-button icon="magicon-repeat" :disabled="!canReplace || disabled" @click="showActionModal('REPLACE')">Vervangen</cms-action-button>
        <cms-action-button icon="entypo-shuffle" v-if="userIsAdmin" :disabled="!canTransfer || disabled" @click="showActionModal('TRANSFER')">Overdragen</cms-action-button>
        <cms-action-button icon="magicon-clock" v-if="userIsAdmin" :disabled="!canChangeActionDeadline || disabled" @click="showChangeActionDeadlineModal">Afhandelingstermijn wijzigen</cms-action-button>
    </cms-action-grid>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'

    import map from 'lodash/map'

    import LoggerState from 'app/enums/LoggerState'

    import LoggerActionModel from 'app/components/modals/LoggerActionModal.vue'
    import ActionDeadlineModal from 'app/components/modals/ActionDeadlineModal.vue'

    @Component({

        name: 'logger-action-grid',
        props: ['loggers', 'entries', 'actionMode', 'disabled']
    })
    export default class extends Vue
    {
        get canDeploy(){

            return this.allow([LoggerState.AVAILABLE, LoggerState.RETURNING]);
        }

        get canReturn(){

            return this.allow([LoggerState.DEPLOYED]);
        }

        get canChangeActionDeadline(){

            return this.allow([LoggerState.DEPLOYED]);
        }

        get canRelease(){

            return this.allow([LoggerState.RETURNING, LoggerState.REPAIR_PENDING, LoggerState.REPAIR_ACTIVE, LoggerState.WRITTEN_OF]);
        }

        get canRepairPending(){

            return this.allow([LoggerState.RETURNING, LoggerState.AVAILABLE, LoggerState.DEPLOYED]);
        }

        get canRepairActive(){

            return this.allow([LoggerState.REPAIR_PENDING]);
        }

        get canWriteOff(){

            return this.allow([LoggerState.RETURNING, LoggerState.REPAIR_PENDING, LoggerState.REPAIR_ACTIVE]);
        }

        get canCreateAction(){

            return this.resolvedLoggers.length == 1 && this.allow([LoggerState.DEPLOYED]);
        }

        get canTransfer(){

            return this.allow([LoggerState.DEPLOYED]);
        }

        get canReplace(){

            return this.resolvedLoggers.length == 1 && this.allow([LoggerState.DEPLOYED]);
        }

        get userIsAdmin(){

            return this.$user.role == 'ADMIN';
        }

        showActionModal(action){

            this.$modal.show(LoggerActionModel, {

                loggers: this.loggers,
                entries: this.entries,
                action

            }).then(({result}) => {

                if(result === true){
                    this.$emit('executed');
                }
            });
        }

        showChangeActionDeadlineModal(){

            const loggers = this.loggers || map(this.entries, 'logger');

            this.$modal.show(ActionDeadlineModal, { loggers }).then(({result}) => {

                if(result === true){
                    this.$emit('executed');
                }
            });
        }

        createAction(){

            this.$router.push({
                name: 'action-add',
                params: { loggerId: this.resolvedLoggers[0].id }
            });
        }

        allow(states){

            var loggers = this.resolvedLoggers;

            if(loggers.length == 0){
                return false;
            }

            var allowed = true;

            loggers.forEach(logger => {

                if(states.indexOf(logger.state) == -1){
                    allowed = false;
                }
            });

            return allowed;
        }

        get resolvedLoggers(){

            return this.entries ? map(this.entries, 'logger') : this.loggers;
        }
    }

</script>
